define(function(require) {
	var IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/core/views/instruments',
		url: function() {
			var parameters = '';
			if (this.urlParameters != undefined) {
				parameters = builder.buildUrlParameters(this.urlParameters)
			}
			if (this.lightweightextensions === true) {
				if (parameters.indexOf('?') >= 0) {
					parameters += '&lightweightextensions=true';
				} else {
					parameters += '?lightweightextensions=true';
				}
			}
			var ret = this.urlRoot +'/'+this.instrumentType+'/'+this.instrumentId+parameters;
			return ret;
		}
	});
});